// extracted by mini-css-extract-plugin
export var standaloneTable = "_2a-0";
export var standaloneTableWithBodyFill = "_2a-1";
export var withExtraHeader = "_2a-2";